/**
 * Returns the canonical origin to use for auth email redirect links.
 *
 * Auth emails (password reset, signup confirmation) are sent server-side and
 * the link the user clicks must point at the production app — NEVER at a
 * lovable.app preview/staging URL, since those rotate per build and look
 * untrustworthy to the user.
 *
 * - On lovable.app / lovableproject.com / localhost → force https://geniebot.pro
 * - On a real production domain (geniebot.pro, geniebot.tools, etc.) → keep it
 */
export const CANONICAL_ORIGIN = "https://geniebot.pro";

export function getAuthRedirectOrigin(): string {
  if (typeof window === "undefined") return CANONICAL_ORIGIN;
  const host = window.location.hostname;
  const isPreview =
    host === "localhost" ||
    host === "127.0.0.1" ||
    host.endsWith(".lovable.app") ||
    host.endsWith(".lovableproject.com") ||
    host.endsWith(".lovable.dev");
  return isPreview ? CANONICAL_ORIGIN : window.location.origin;
}
